import { render, staticRenderFns } from "./Snippets.vue?vue&type=template&id=5706c8db&"
import script from "./Snippets.vue?vue&type=script&lang=js&"
export * from "./Snippets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports